/*
Se usa https://nickpiscitelli.github.io/Glider.js/
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/glider-js@1/glider.min.css">  
<script src="https://cdn.jsdelivr.net/npm/glider-js@1/glider.min.js"></script>
*/
import { urlBaseApi, obtenerSrcset } from './comun'
import articulus from './articulus'

export function iniciarLibros() {
  let url = `${urlBaseApi}/apis/articulus/v1/blogs/libros_es/articulos/?orden=crono&ordenDir=desc&pag=1&porPag=20&categoria=portada`
  listarLibros(url, document.querySelector('.plantilla.libro'), document.querySelector('.slider-libros'))
  //
  function listarLibros (urlApi, plantilla, contenedor) {
    articulus(urlApi, 'es').then(artis => {
      mostrarArticulos(artis)
    }).catch(error => { console.log(error) })

    function mostrarArticulos (artis) {
      if (artis.articulos.length > 0) {
        artis.articulos.forEach(arti => {
          const articulo = plantilla.cloneNode(true) // Clona plantilla
          //
          articulo.querySelector('.imagen img').src = urlBaseApi + arti.imgPrincipal
          articulo.querySelector('.imagen img').srcset = obtenerSrcset(urlBaseApi + arti.imgPrincipal)
          articulo.querySelector('.imagen img').alt = arti.titulo
          //
          try {
            // Cambia comillas dobles por simples dentro de enlaces. Convierte <a href="#"> en <a href='#'>
            const enlaces = arti.entradilla.matchAll(/<a\s[^<]*>/g) // Busca enlaces
            let enlaceNuevo
            for (const enlace of enlaces) {
              enlaceNuevo = enlace[0].replace(/\"/g, "'") // Cambia comillas
              arti.entradilla = arti.entradilla.replace(enlace[0], enlaceNuevo) // Reemplaza enlace en el contenido
            }
            //
            let datosEnIntro = JSON.parse(arti.entradilla)
            articulo.querySelector('.intro').innerHTML = datosEnIntro.intro || ''
          } catch (e) {
            articulo.querySelector('.intro').innerHTML = ''
          }
          //
          const enlaces = articulo.querySelectorAll('.enlace')
          for (const enlace of enlaces) {
            enlace.href = `/libro/${arti.tituloUrl}`
          }
          contenedor.appendChild(articulo) // Agrega plantilla al contenedor
          articulo.classList.remove('plantilla') // y la hace visible
        })
        let sliderLibros = new Glider(document.querySelector('.slider-libros'), {
          slidesToShow: 1,
          dots: '#dots',
          draggable: true,
          easing: function (x, t, b, c, d) {
            return c*(t/=d)*t + b
          }
        })
        // Animación
        let totalDiapos = document.querySelectorAll('.slider-libros .libro').length
        let diapoActual = -1
        window.setInterval(() => {
          diapoActual ++
          if (diapoActual >= totalDiapos) {
            diapoActual = 0
          }
          sliderLibros.scrollItem(diapoActual, true)
        }, 4000)
      }
    }
  }
}
